<template>
  <Teleport to="body">
    <div v-if="modelValue" class="loading-toast">
      <div class="loading-toast__body">
        <BbIcon v-if="onClose" name="warning-circle" size="medium" type="filled" class="warning-icon" />

        <div class="loading-toast__title" :class="{ 'padding-top': !onClose }">
          <TextBody :i18n-key="title" tag="div" :body-type="3" color="#fff" />
          <TextBody :i18n-key="subtitle" tag="div" :body-type="3" weight="medium" color="#fff" />
        </div>

        <div class="divider" v-if="onClose" />

        <BbBtn
          v-if="onClose"
          size="medium"
          icon-size="medium"
          icon="x-small"
          is-icon-button
          type="icon"
          no-background
          button-type="outlined"
          class="close-button"
          @click="onClose"
        />
      </div>

      <div class="loading-toast__bar" v-if="!onClose">
        <div class="loading-toast__bar-fill" :style="{ width: progress + '%' }" />
      </div>
    </div>
  </Teleport>
</template>

<script>
import TextBody from '~/components/common/TextBody.vue';

export default {
  name: 'LoadingToast',
  components: { TextBody },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    progress: {
      type: Number,
      default: 0,
    },
    onClose: {
      type: Function,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-toast {
  border-radius: 4px;
  border-radius: 4px;
  border: 1px solid #000;
  background: $bb-neutral-1;
  box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 160px;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;
  z-index: 9999;
  padding: 0 $bb-spacing-3;

  .divider {
    height: 60px;
    width: 1px;
    background: $bb-neutral-2;
  }

  .close-button {
    margin: auto;

    :deep(.v-btn__content) {
      i {
        color: $bb-neutral-0;
      }
    }
  }

  .warning-icon {
    background-color: $bb-neutral-0;
    border-radius: 50%;
    margin-top: $bb-spacing-3;
    color: #b75854;
  }

  &__body {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: $bb-spacing-2;
  }

  &__title {
    margin: auto;

    :deep(.font-weight-regular:first-of-type) {
      font-weight: 600 !important;
    }
  }

  &__bar {
    width: 90%;
    height: 4px;
    background: $bb-neutral-3;
    overflow: hidden;
    border-radius: 4px;
    margin: $bb-spacing-1 0 $bb-spacing-2 0;

    &-fill {
      height: 100%;
      background: $bb-interface-7;
      border-radius: 2px;
      transition: width 0.5s ease-in-out;
    }
  }

  .padding-top {
    padding-top: $bb-spacing-3;
  }
}
</style>
